@if (variant === 'inline') {
  <div class="profile-card__password-fields" [formGroup]="passwordForm" (keydown.enter)="$event.preventDefault(); onSubmit()">
    <app-input
      type="password"
      [label]="'profile.changePassword.currentPassword' | transloco"
      [required]="true"
      formControlName="currentPassword"
      [error]="!!passwordForm.get('currentPassword')?.invalid && !!passwordForm.get('currentPassword')?.touched"
      [errorMessage]="getErrorMessage('currentPassword') || ''"
      size="small"
      />
    <app-input
      type="password"
      [label]="'profile.changePassword.newPassword' | transloco"
      [required]="true"
      formControlName="newPassword"
      [error]="!!passwordForm.get('newPassword')?.invalid && !!passwordForm.get('newPassword')?.touched"
      [errorMessage]="getErrorMessage('newPassword') || ''"
      size="small"
      />
    <app-input
      type="password"
      [label]="'profile.changePassword.confirmPassword' | transloco"
      [required]="true"
      formControlName="confirmPassword"
      [error]="!!passwordForm.get('confirmPassword')?.invalid && !!passwordForm.get('confirmPassword')?.touched"
      [errorMessage]="getErrorMessage('confirmPassword') || ''"
      size="small"
      />
    <div class="profile-card__password-actions">
      <app-button
        [label]="isLoading ? ('common.labels.loading' | transloco) : ('profile.changePassword.button' | transloco)"
        type="button"
        size="small"
        [disabled]="isLoading"
        (click)="onSubmit()"
      ></app-button>
      <app-button
        [label]="'common.actions.cancel' | transloco"
        variant="ghost"
        type="button"
        size="small"
        [disabled]="isLoading"
        (click)="close()"
      ></app-button>
    </div>
  </div>
} @else if (!success) {
    <div class="modal-header">
        <h2 class="modal-title">{{ 'profile.changePassword.title' | transloco }}</h2>
        <button type="button" class="close-btn" (click)="close()" [attr.aria-label]="'common.actions.close' | transloco">
            <lucide-icon class="custom-icon" name="X"></lucide-icon>
        </button>
    </div>

    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="form">
        <div class="input-field">
            <app-input
                type="password"
                [label]="'profile.changePassword.currentPassword' | transloco"
                [required]="true"
                formControlName="currentPassword"
                [error]="!!passwordForm.get('currentPassword')?.invalid && !!passwordForm.get('currentPassword')?.touched"
                [errorMessage]="getErrorMessage('currentPassword') || ''"
                icon="Lock"
                size="medium"
            ></app-input>
        </div>

        <div class="input-field">
            <app-input
                type="password"
                [label]="'profile.changePassword.newPassword' | transloco"
                [required]="true"
                formControlName="newPassword"
                [error]="!!passwordForm.get('newPassword')?.invalid && !!passwordForm.get('newPassword')?.touched"
                [errorMessage]="getErrorMessage('newPassword') || ''"
                icon="Lock"
                size="medium"
            ></app-input>
        </div>

        <div class="input-field">
            <app-input
                type="password"
                [label]="'profile.changePassword.confirmPassword' | transloco"
                [required]="true"
                formControlName="confirmPassword"
                [error]="!!passwordForm.get('confirmPassword')?.invalid && !!passwordForm.get('confirmPassword')?.touched"
                [errorMessage]="getErrorMessage('confirmPassword') || ''"
                icon="Lock"
                size="medium"
            ></app-input>
        </div>

    <app-button
        [label]="isLoading ? ('common.labels.loading' | transloco) : ('profile.changePassword.button' | transloco)"
        class="submit-button"
        size="medium"
        type="submit"
        [disabled]="isLoading"
    ></app-button>
    </form>
} @else {
    <div class="success-container">
        <div class="success-icon">
            <lucide-icon name="CircleCheck" class="check"></lucide-icon>
        </div>
        <p class="success-title">{{ 'profile.changePassword.success' | transloco }}</p>
        <app-button
            [label]="'profile.changePassword.close' | transloco"
            class="close-button"
            size="medium"
            (click)="close()"
        ></app-button>
    </div>
}
